export default __webpack_public_path__ + "static/media/img9.d76f936b.jpg";